import { render } from "./FinesView.vue?vue&type=template&id=b3fe8c2c"
import script from "./FinesView.vue?vue&type=script&lang=js"
export * from "./FinesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__